// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
function IconDown(Props) {
  var className = Props.className;
  var tmp = {
    height: "17",
    width: "16",
    viewBox: "0 0 16 17"
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement("svg", tmp, React.createElement("path", {
    d: "M1.125 6.1875C1.21875 6.0625 1.34375 6 1.5 6C1.59375 6 1.71875 6.03125 1.8125 6.125L7.96875 11.7812L14.1562 6.125C14.3438 5.9375 14.6562 5.9375 14.8438 6.15625C15.0312 6.34375 15.0312 6.65625 14.8125 6.84375L8.3125 12.8438C8.125 13.0312 7.84375 13.0312 7.65625 12.8438L1.15625 6.84375C0.9375 6.6875 0.9375 6.375 1.125 6.1875Z",
    fill: "currentColor"
  }));
}
IconDown.displayName = "IconDown";
var make = React.memo(IconDown);
export { make };
/* make Not a pure module */